import One from '../../../images/one.jpg'
import Two from '../../../images/two.jpg'
import Three from '../../../images/three.jpg'
import Four from '../../../images/four.jpg'
import Five from '../../../images/five.jpg'
import Six from '../../../images/six.jpg'
import Seven from '../../../images/seven.jpg'
import Eight from '../../../images/eight.jpg'
import Nine from '../../../images/nine.jpg'
import Ten from '../../../images/ten.jpg'
import Home1 from '../../../images/home1.jpg'
import Home2 from '../../../images/home2.jpg'
import Toile1 from '../../../images/toile1.jpg'
import Toile2 from '../../../images/toile2.jpg'
import { Link } from 'react-router-dom';


export default function Home({ products, categories }) {
    
    return (
      <div className='bg-white'>
      <div className="relative overflow-hidden bg-white">
        <div className="pb-80 pt-28 sm:pb-40 sm:pt-36 lg:pb-48 lg:pt-40 ">
          <div className="relative mx-auto max-w-7xl px-4 sm:static sm:px-8 lg:px-12">
            <div data-aos="zoom-in" className="sm:max-w-lg sm:pt-20">
              <h1 className="text-4xl font-bold tracking-tight text-black sm:text-6xl">
                Bienvenue chez Rokasa
              </h1>
              <p className="mt-4 text-xl text-gray-700">
              Découvrez notre collection exclusive de produits. Parcourez nos catalogues pour trouver le
              matériau parfait pour vos besoins, que ce soit pour la mode, la décoration intérieure ou d'autres
              applications créatives.
              </p>
            </div>
            <div>
              <div className="mt-10">
                {/* Decorative image grid */}
                <div
                  aria-hidden="true"
                  className="pointer-events-none lg:absolute lg:inset-y-0 lg:mx-auto lg:w-full lg:max-w-7xl"
                >
                  <div className="absolute transform sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
                    <div className="flex items-center space-x-6 lg:space-x-8">
                      <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                        <div className="h-64 w-44 overflow-hidden rounded-lg sm:opacity-0 lg:opacity-100">
                          <img
                            src={Home1}
                            alt=""
                            className="h-full w-full object-cover object-center"
                          />
                        </div>
                        <div className="h-64 w-44 overflow-hidden rounded-lg">
                          <img
                            src={One}
                            alt=""
                            className="h-full w-full object-cover object-center"
                          />
                        </div>
                      </div>
                      <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                        <div className="h-64 w-44 overflow-hidden rounded-lg">
                          <img
                            src={Toile1}
                            alt=""
                            className="h-full w-full object-cover object-center"
                          />
                        </div>
                        <div className="h-64 w-44 overflow-hidden rounded-lg">
                          <img
                            src={Home2}
                            alt=""
                            className="h-full w-full object-cover object-center"
                          />
                        </div>
                        <div className="h-64 w-44 overflow-hidden rounded-lg">
                          <img
                            src={Eight}
                            alt=""
                            className="h-full w-full object-cover object-center"
                          />
                        </div>
                      </div>
                      <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                        <div className="h-64 w-44 overflow-hidden rounded-lg">
                          <img
                            src={Six}
                            alt=""
                            className="h-full w-full object-cover object-center"
                          />
                        </div>
                        <div className="h-64 w-44 overflow-hidden rounded-lg">
                          <img
                            src={Nine}
                            alt=""
                            className="h-full w-full object-cover object-center"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                <Link 
                  to={`/new-collection`}
                  className="inline-block rounded-md border border-transparent bg-black px-4 py-3 text-center font-medium text-white hover:bg-gray-900"
                  >
                  Achetez maintenant
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white">
      <div className="mx-auto max-w-2xl px-4 py-16 sm:px-4 lg:py-16 lg:max-w-7xl lg:px-12">
        <div className=' mb-10 flex justify-between items-center'>
          <h2 className='text-4xl font-light tracking-tight text-black sm:text-6xl'>Nouvelle Collection</h2>
          <div className="bg-black py-1 px-2.5 rounded-full">
            <Link to='/new-collection' className='text-sm text-white font-semibold' >Voir plus</Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 xl:gap-x-8">
          {products.map((product, index) => index < 4 &&  (
            <div data-aos="zoom-in">
              <Link  to={`/product/${product.id}`} className="group" >
                <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
                  <img
                    src={product.image}
                    alt={product.slug}
                    className="h-full w-full object-cover object-center group-hover:opacity-75"
                  />
                </div>
                <div className='flex justify-between items-end'>
                  <h3 className="mt-4 text-sm text-gray-900">{product.name}</h3>
                  <p className="mt-1 text-lg font-medium text-gray-900">${product.price}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>

    <div className="bg-black">
      <div className="mx-auto max-w-2xl px-4 py-8 sm:px-4 lg:py-10 lg:max-w-7xl lg:px-12">
        <div className=' mb-10 flex justify-between items-center'>
          <h2 className='text-4xl font-light tracking-tight text-white sm:text-6xl'>Achetez par catégorie</h2>
          {/* <div className="bg-black py-1 px-2.5 rounded-full">
            <Link to='/new-collection' className='text-sm text-white font-semibold'>Voir plus</Link>
          </div> */}
        </div>

        <div className="grid grid-cols-2  gap-x-6 gap-y-10 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 xl:gap-x-8">
          {categories.map((category, index) => (
            <div data-aos="fade-up">
              <div  className="relative block group">
                <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
                  <img
                    src={category.image}
                    alt=''
                    className="absolute inset-0 object-cover w-full h-full group-hover:opacity-75"
                  />
                  <div className='flex justify-between items-end '>
                    <div className='flex py-0 sm:py-2 justify-between bg-gradient-to-r from-yellow-700 w-full'>
                      <h3 className="p-2 object-bottom text-sm sm:text-xl font-bold text-white ">{category.name}</h3>
                      <div class="transition-all transform translate-y-8 opacity-0 group-hover:opacity-100 group-hover:translate-y-0">
                        <div class="p-2">
                          <Link to={`/${category.slug}`}  class="px-4 py-2 text-sm rounded text-white bg-black hover:bg-gray-900" >Voir</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          
        </div>
      </div>
    </div>

    {/* <div className="bg-white h-52">
    
    </div> */}

    </div>
    )
  }
  